import React from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {InfoCard2} from '../../widgets/components/UI/InfoCard2'
import {RecordsKeeperAIBreadCrumbs} from '../core/_constants'
import {useIntl} from 'react-intl'
import SearchAndFiltersDataTable from '../components/SearchAndFilters/SearchAndFiltersDataTable'

const SearchAndFilters = () => {
  const {formatMessage} = useIntl()
  
  return (
    <>
      <div>
        <PageTitle
          breadcrumbs={RecordsKeeperAIBreadCrumbs}
          description={formatMessage({id: 'Search & Filter'})}
        >
          {formatMessage({id: 'RecordsKeeper AI'})}
        </PageTitle>
      </div>

      <div className='px-6'>
        <InfoCard2
          title={'Search & Filter Your Files'}
          desc={
            'Easily find your uploaded and processed files using the search bar or by applying advanced filters. Use this page when you can`t locate documents through other sections like Records & Files, Query, or Prompt. These search and filter options give you better control to quickly pinpoint the exact records you need — saving time and ensuring nothing gets lost.'
          }
          slug={`https://help.recordskeeper.ai/en/articles/11064598-advanced-search-filters-find-any-document-in-seconds`}
        />
        <SearchAndFiltersDataTable />
      </div>
    </>
  )
}

export default SearchAndFilters
